import { Button } from "@chakra-ui/react";

type IProps = {
  onClick: () => void;
  isLoading?: boolean;
};

const ContinueBtn = ({ onClick, isLoading }: IProps) => {
  return (
    <Button
      size="lg"
      borderRadius="1rem"
      isLoading={isLoading}
      width="100%"
      variant={"secondary"}
      onClick={onClick}
      _active={{
        transform: "scale(0.95)",
        transition: ".1s",
      }}
    >
      Continue
    </Button>
  );
};

export default ContinueBtn;
